export default {
  path: '/performance',
  name: 'PerformanceIndex',
  redirect: '/performance/index',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    { // 指标组 考核阶段管理
      path: 'index',
      component: () => import('@/views/performance/Index'),
      meta: { requiresAuth: true }
    },
    { // 一级指标
      path: 'indicator/:groupUuid',
      component: () => import('@/views/performance/FirstTargetList'),
      meta: { requiresAuth: true }
    },
    { // 二级指标
      path: '/secondIndicator/:groupUuid/:upTargetUuid',
      component: () => import('@/views/performance/SecondTargetList'),
      meta: { requiresAuth: true }
    },
    { // 机构待审核阶段列表
      path: 'phaselist',
      component: () => import('@/views/performance/IndicatorPhase'),
      meta: { requiresAuth: true }
    },
    { // 提交审核
      path: 'upload',
      component: () => import('@/views/performance/IndicatorUpload'),
      meta: { requiresAuth: true }
    },
    { // 提交审核 提交审核首页
      path: 'uploadHome',
      component: () => import('@/views/performance/IndicatorUploadHome'),
      meta: { requiresAuth: true }
    },
    { // 提交审核 提交审核状态
      path: 'uploadStatus',
      component: () => import('@/views/performance/IndicatorUploadStatus'),
      meta: { requiresAuth: true }
    },
    { // 提交审核 提交审核状态
      path: 'uploadStatusOutTime',
      component: () => import('@/views/performance/IndicatorUploadStatusOutTime'),
      meta: { requiresAuth: true }
    },
    { // 系统管理员审核页面
      path: 'auditlist',  // PerformanceForRoles.vue
      component: () => import("@/views/performance/PerformanceForRoles"),
      meta: { requiresAuth: true }
    },
    { // 系统管理员审核页面， 机构等上传的资料详情页
      path: 'auditlistdetail',
      component: () => import("@/views/performance/performanceForDetails"),
      meta: { requiresAuth: true }
    },
    { // 文件库列表页
      path: 'docList',
      component: () => import("@/views/performance/components/DocumentLibraryList"),
      meta: { requiresAuth: true }
    },
    { // 审核页 供青训中心用
      path: 'orgCheck',
      component: () => import("@/views/performance/performanceCheck"),
      meta: { requiresAuth: true }
    },
    { // 审核页 供青训中心用 待评估机构列表
      path: 'orgCheckUndo',
      component: () => import("@/views/performance/performanceCheckUndo"),
      meta: { requiresAuth: true }
    },
    { // 审核页 供青训中心用 待评估机构列表
      path: 'orgCheckDetails',
      component: () => import("@/views/performance/performanceCheckDetails"),
      meta: { requiresAuth: true }
    },
    { // 专家列表（分配俱乐部及指标）
      path: 'allocationExportsList',
      component: () => import("@/views/performance/allocation/ExportList"),
      meta: { requiresAuth: true }
    },
    { // 专家 分配俱乐部
      path: 'allocationSchool',
      component: () => import("@/views/performance/allocation/ExportListForSchool"),
      meta: { requiresAuth: true }
    },
    { // 专家 分配指标
      path: 'allocationPerformance',
      component: () => import("@/views/performance/allocation/ExportListForPerformance"),
      meta: { requiresAuth: true }
    },
    { // 专家 分配日常管理指标
      path: 'allocationPerformanceBaseType',
      component: () => import("@/views/performance/allocation/ExportListForBaseType"),
      meta: { requiresAuth: true }
    },
  ]
}
